import RangeInput from '@/components/QueryWidgets/RangeInputV2'
import FuzzyMatchSelectComponent from '@/components/QueryWidgets/FuzzyMatchSelectComponent'

// 是否是对象
export const isObj = (value: any) => Object.prototype.toString.call(value) === '[object Object]'

// 是否是时间范围
export const isTimeRage = ({ value }: any) =>
    isObj(value) && (value.hasOwnProperty('startTime') || value.hasOwnProperty('endTime'))

// 是否是数字区间（无法通过数据辨别）
export const isNumberRange = ({ field }: any) => field.valueType === 'NUMBER_RANGE' || field.component === RangeInput

// 是否选择
export const isSelect = ({ field, localData }: any) => {
    return Array.isArray(field.props?.options) || Array.isArray(localData?.options)
}

// 是否单选
export const isSingleSelect = ({ field, localData }: any) => {
    return isSelect({ field, localData }) && !(field.props.mode === 'multiple') && !(localData?.mode === 'multiple')
}

// 是否多选
export const isMultipleSelect = ({ field, localData }: any) => {
    return isSelect({ field, localData }) && (field.props.mode === 'multiple' || localData?.mode === 'multiple')
}

// 是否是资料编码、商品编码框
export const isFuzzyMatchSelect = ({ field }) => {
    return field.component === FuzzyMatchSelectComponent
}
